function Four04() {
  return (
    <div>
      <section className="internal-page-wrapper my-5">
        <div className="container">
          <div className="row h-100 align-items-center justify-content-center text-center">
            <div className="col-12 mt-5">
              <h1 className="font-weight-bold">
                The page you’re looking for can’t be found.
              </h1>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Four04;
